import * as React from "react";
import { Cloud, Code, Network, Terminal } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const features = [{
  title: "Proprietary Panel System",
  description: "Our engineered fiber-reinforced concrete panels allow you to build massive outdoor structures in a fraction of the time compared to traditional masonry methods.",
  icon: Network,
  spanClass: "md:col-span-2",
  specs: ["MATERIAL: GFRC", "WEIGHT: LIGHTWEIGHT", "STRENGTH: HIGH-IMPACT"]
}, {
  title: "Reduced Labor Costs",
  description: "Eliminate the need for heavy machinery and large crews. Two installers can complete projects that used to take weeks in just a few days.",
  icon: Cloud,
  spanClass: "md:col-span-1",
  specs: ["CREW: 2-3 PERSONS", "TIME: -70% REDUCTION"]
}, {
  title: "Weather-Resistant Tech",
  description: "Designed to withstand extreme freeze-thaw cycles and harsh environments. ClifRock structures are built for longevity and zero maintenance for your clients.",
  icon: Code,
  spanClass: "md:col-span-3",
  specs: ["RATING: ALL-CLIMATE", "WARRANTY: LIFETIME", "FINISH: NATURAL STONE"]
}];
export default function TheClifrockAdvantage() {
  return <section data-section-id="253065" id="the-clifrock-advantage" className="bg-background text-foreground relative overflow-hidden py-20 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-[0.03]"></div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16 max-w-2xl">
          <div className="mb-4 flex items-center gap-2 text-primary">
            <Terminal className="size-5" />
            <span className="font-default text-sm font-semibold tracking-wider uppercase">
              The ClifRock Advantage
            </span>
          </div>
          <h2 className="font-default mb-6 text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
            Engineered for Growth
          </h2>
          <p className="font-default text-muted-foreground text-lg leading-relaxed">
            ClifRock provides contractors with the technology and training needed to dominate the outdoor living market. Build faster, smarter, and more profitably.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <Card key={index} data-index={index} className={`group relative overflow-hidden border-none bg-card shadow-md transition-all duration-400 hover:-translate-y-2 hover:shadow-xl ${feature.spanClass}`}>
                {}
                <div className="absolute top-6 right-6 text-primary transition-colors group-hover:text-primary/80">
                  <Icon className="size-12 sm:size-16" strokeWidth={1.5} />
                </div>

                <CardHeader className="relative z-10 pb-4">
                  <CardTitle className="font-default text-xl font-semibold text-foreground sm:text-2xl">
                    {feature.title}
                  </CardTitle>
                  <CardDescription className="max-w-[85%] font-default text-base leading-relaxed text-muted-foreground">
                    {feature.description}
                  </CardDescription>
                </CardHeader>

                <CardContent className="relative z-10 mt-auto pt-6">
                  <div className="border-t border-border/30 pt-6">
                    <p className="mb-3 font-default text-xs font-semibold tracking-wider text-primary uppercase">
                      Performance Specs
                    </p>
                    <div className="flex flex-wrap gap-2 sm:gap-4">
                      {feature.specs.map((spec, specIndex) => <span key={specIndex} data-index={specIndex} className="rounded-md bg-muted px-2.5 py-1 font-default text-xs font-medium text-foreground/80">
                          {spec}
                        </span>)}
                    </div>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}